// Manually created file of the Bundle.displayMethod dropdown options from Contentful.
// https://app.contentful.com/spaces/4gvqtjbll1oj/content_types/bundle/fields

export enum ContentfulBundleDisplayMethod {
  Deferred = 'Deferred',
  Featured = 'Featured',
  PoseBackgroundSelection = 'Pose Background Selection',
  Retouching = 'Retouching',
  Standard = 'Standard'
}
